<script lang="ts">
	import { t } from 'svelte-intl-precompile';
	import { page } from '$app/state';
	import Logo from '$lib/assets/svg/logo_header.svg?component';
	import SideBarMobile from '$lib/components/molecules/SideBarMobile/SideBarMobile.svelte';
	import { type MenuItem } from '$lib/utils/menu';
	import { HOME_URL } from '$lib/consts';
	import Breadcrumbs from '$lib/components/atoms/Breadcrumbs/Breadcrumbs.svelte';
	import { getBreadcrumbsFromUrl } from '$lib/utils';

	interface Props {
		animated?: boolean;
		menu?: MenuItem[];
		showBreadcrumbs?: boolean;
	}

	let { animated = false, menu = [], showBreadcrumbs = true }: Props = $props();

	let fundName = $derived(page.data?.fundData?.name ?? page.data?.page?.data?.title);
	let breadcrumbs = $derived(
		showBreadcrumbs ? getBreadcrumbsFromUrl(page.url.href, menu, fundName, $t) : []
	);

	// Remove undefined breadcrumbs which can appear due to invalid url
	let validBreadcrumbs = $derived(breadcrumbs.filter(({ label }) => label));
</script>

<div class="Header" class:Header--animated={animated}>
	<div class="Header__inner">
		<div class="Header__left-wrapper">
			{#if validBreadcrumbs.length > 2}
				<div class="Header__breadcrumbs--desktop">
					<Breadcrumbs items={validBreadcrumbs}></Breadcrumbs>
				</div>
			{/if}
			<div class="Header__menu-button-wrapper">
				<SideBarMobile {menu}></SideBarMobile>
			</div>
		</div>
		<div class="Header__right-wrapper">
			<a
				data-testid="Header_Logo"
				href={HOME_URL}
				class="Header__logo-icon"
				aria-label={$t('meta.siteName')}
			>
				<Logo></Logo>
			</a>
		</div>
	</div>
	{#if validBreadcrumbs.length}
		<div class="Header__breadcrumbs--mobile">
			<Breadcrumbs items={validBreadcrumbs}></Breadcrumbs>
		</div>
	{/if}
</div>

<style lang="scss" src="./Header.scss"></style>
